










































exports.default = {
  data: ->
    info: null
    user: null

  props:
    hide_on_confirm:
      default: true

  methods:
    confirm: (flag_finish) ->
      jQuery("#change-responsability").modal 'hide' if @hide_on_confirm
      @$emit 'confirm-modal-confirm', { user: @user, flag_finish: flag_finish }

    reject: ->
      @$emit 'confirm-modal-reject'

    show: (data) ->
      @info = data.data
      @user = data.user
      jQuery("##{data.id}").modal 'show'

    loadInfo: ->
      @contact_resource.transferInfo @loadInfoSuccess, @unknownError,


  created: ->
    EventsBus.$on 'confirm-modal-show', @show
    @contact_resource = new ContactsResource Session.current_company.id

  beforeDestroy: ->
    EventsBus.$off 'confirm-modal-show', @show
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/contacts/change_responsability_modal.vue